import queryClient from "../queryClient";
import { RESERVATIONS_KEY } from "./hooks";

export function invalidateReservationQueries() {
    return queryClient.invalidateQueries({ queryKey: [RESERVATIONS_KEY, ]});   
}


// WEBPACK FOOTER //
// ./src/queries/reservations/utils.js